export enum elementPosition {
    top = "top",
    bottom = "bottom",
    left = "left",
    right = "right"
}